import { defineComponent, ref, computed, toRef } from 'vue-demi';
import './TimeFormat-a7f5565b.js';
import './dom-53c9635b.js';
import '@vueuse/core';
import { u as usePopoverState } from './usePopoverState-7267fa91.js';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import { R as ResizeablePanelPadding, s as script$1 } from './OrResizeablePanel-1d0c171b.js';
import { resolveComponent, openBlock, createBlock, createSlots, withCtx, createElementVNode, normalizeClass, createElementBlock, renderSlot, createCommentVNode } from 'vue';

const Sidebar = [
// Layout
'layout-column grow',
// Overflow
'overflow-hidden'];
const SidebarHeader = [
// Layout
'shrink-0',
// Overflow
'overflow-hidden',
// Typography
'typography-headline-2 truncate'];
const SidebarHeaderPaddings = {
  [ResizeablePanelPadding.L]: [
  // Box
  'px-lg', 'py-lg'],
  [ResizeablePanelPadding.M]: [
  // Box
  'px-md', 'py-md'],
  [ResizeablePanelPadding.S]: [
  // Box
  'px-sm', 'py-sm'],
  [ResizeablePanelPadding.None]: []
};
const SidebarContent = [
// Layout
'grow',
// Overflow
'overflow-auto'];
const SidebarContentPaddings = {
  [ResizeablePanelPadding.L]: [
  // Box
  'px-lg', 'py-lg'],
  [ResizeablePanelPadding.M]: [
  // Box
  'px-md', 'py-md'],
  [ResizeablePanelPadding.S]: [
  // Box
  'px-sm', 'py-sm'],
  [ResizeablePanelPadding.None]: []
};
const SidebarFooter = [
// Layout
'shrink-0',
// Overflow
'overflow-hidden',
// Theme
'theme-border-outline-variant border-t-1', 'dark:theme-border-outline-variant-dark'];
const SidebarFooterPaddings = {
  [ResizeablePanelPadding.L]: [
  // Box
  'px-lg', 'py-lg'],
  [ResizeablePanelPadding.M]: [
  // Box
  'px-md', 'py-md'],
  [ResizeablePanelPadding.S]: [
  // Box
  'px-sm', 'py-sm'],
  [ResizeablePanelPadding.None]: []
};

var script = defineComponent({
  name: 'OrSidebar',
  components: {
    OrResizeablePanel: script$1
  },
  props: {
    isOpen: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 320
    },
    minWidth: {
      type: Number,
      default: undefined
    },
    maxWidth: {
      type: Number,
      default: undefined
    },
    padding: {
      type: String,
      default: () => ResizeablePanelPadding.M
    },
    placement: {
      type: String,
      default: undefined
    },
    resizeable: {
      type: Boolean,
      default: undefined
    },
    collapsible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:state', 'open', 'close', 'resize'],
  expose: ['root', 'state', 'open', 'close', 'toggle'],
  setup(props, context) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-sidebar-v3', ...Sidebar]);
    const headerStyles = computed(() => [...SidebarHeader, ...SidebarHeaderPaddings[props.padding]]);
    const contentStyles = computed(() => [...SidebarContent, ...SidebarContentPaddings[props.padding]]);
    const footerStyles = computed(() => [...SidebarFooter, ...SidebarFooterPaddings[props.padding]]);
    // State
    const {
      state,
      open,
      close,
      toggle
    } = usePopoverState(toRef(props, 'isOpen'), context.emit);
    return {
      root,
      rootStyles,
      headerStyles,
      contentStyles,
      footerStyles,
      state,
      open,
      close,
      toggle
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrResizeablePanel = resolveComponent("OrResizeablePanel");
  return openBlock(), createBlock(_component_OrResizeablePanel, {
    "is-open": _ctx.state === 'open',
    width: _ctx.width,
    "min-width": _ctx.minWidth,
    "max-width": _ctx.maxWidth,
    padding: 'none',
    placement: _ctx.placement,
    resizeable: _ctx.resizeable,
    collapsible: _ctx.collapsible,
    "onUpdate:state": _cache[0] || (_cache[0] = $event => $event === 'open' ? _ctx.open() : _ctx.close()),
    onResize: _cache[1] || (_cache[1] = $event => _ctx.$emit('resize', $event))
  }, createSlots({
    default: withCtx(() => [createElementVNode("div", {
      ref: 'root',
      class: normalizeClass(_ctx.rootStyles)
    }, [_ctx.$slots.header ? (openBlock(), createElementBlock("header", {
      key: 0,
      class: normalizeClass(_ctx.headerStyles)
    }, [renderSlot(_ctx.$slots, "header")], 2 /* CLASS */)) : createCommentVNode("v-if", true), createElementVNode("div", {
      class: normalizeClass(_ctx.contentStyles)
    }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */), _ctx.$slots.footer ? (openBlock(), createElementBlock("footer", {
      key: 1,
      class: normalizeClass(_ctx.footerStyles)
    }, [renderSlot(_ctx.$slots, "footer")], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 2 /* CLASS */)]),
    _: 2 /* DYNAMIC */
  }, [!!_ctx.$slots.toolbar ? {
    name: "toolbar",
    fn: withCtx(() => [renderSlot(_ctx.$slots, "toolbar")]),
    key: "0"
  } : undefined]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["is-open", "width", "min-width", "max-width", "placement", "resizeable", "collapsible"]);
}

script.render = render;
script.__file = "src/components/or-sidebar-v3/OrSidebar.vue";

var SidebarPlacement;
(function (SidebarPlacement) {
  SidebarPlacement["Left"] = "left";
  SidebarPlacement["Right"] = "right";
})(SidebarPlacement || (SidebarPlacement = {}));

export { SidebarPlacement as S, script as s };
